import {useTranslation} from "ni18n";
import React from "react";
import {V5Img} from "src/components/_common/Carbon";

import SectionHeader from "./SectionHeader";

type Props = {
  hideStory?: boolean;
};

const AboutUs: React.FC<Props> = ({hideStory}) => {
  const i18n = useTranslation();

  const data = [
    !hideStory && {
      tag: i18n.t("Founded in 2015"),
      header: i18n.t("Our story"),
      paragraphs: [
        i18n.t(
          "Carbon Health is a modern health clinic that provides urgent and primary care for easier everyday health. By combining advanced technology with expert care, we simplify access to a full spectrum of health needs – from acute issues to primary care to chronic conditions.",
        ),
        i18n.t(
          "We’re removing traditional boundaries to make high-quality, transparent, and personal care accessible – because great care should always be within reach, no matter who you are or when and where you need it.",
        ),
      ],
    },
    {
      tag: i18n.t("What we believe"),
      header: i18n.t("Our culture"),
      paragraphs: [
        i18n.t(
          "As a physician-founded and led organization, ensuring everyone has access to quality healthcare is what inspires us. That’s why we hire people who genuinely care about patients, solving healthcare challenges, and making a positive impact every day.",
        ),
        i18n.t(
          "We aim to keep a culture where you can develop your career and continuously refine your craft. Whether you work in one of our clinics or on a corporate team, you have a professional future at Carbon Health with an organization that cares about you. Read on to learn about the values at the core of our culture:",
        ),
      ],
    },
  ].compact();

  return (
    <div className="ph8 pt30 pt12-sm pb10 pos-r">
      <V5Img
        className="pos-a right0 h140 dn-md"
        style={{bottom: -30}}
        src="/illustrations/squiggly-lines"
      />
      <div className="maxw80 ma">
        {data.map((section, i) => (
          <div key={section.tag} className={`df fdc mb${i === data.length - 1 ? "20" : "30"}`}>
            <SectionHeader tag={section.tag} header={section.header} />
            <div className="df fdc-sm font-cm font-ir-sm jcsb maxw70 fs20 mt16 fs16-xs">
              {section.paragraphs.map(p => (
                <p key={p.slice(0, 10)} className="fx maxw28 mr10 mr0-sm mb10 mb5-xs">
                  {p}
                </p>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutUs;
